var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FullscreenPrompt',{attrs:{"message":_vm.$t('store-load-error.note'),"button-text":_vm.$t('store-load-error.reset')},on:{"button-click":_vm.resetState}})
}
var staticRenderFns = []

export { render, staticRenderFns }